import { createApi, retry } from '@reduxjs/toolkit/query/react';
import type {
  PostSessionDTO,
  PostSessionParticipantsDTO,
  LbCallSession,
  GetSessionsInput,
  SessionResultForCsv,
} from '../callSession.types';
import { ogBaseQuery } from '../../ogBaseQuery';

export const callSessionOGService = createApi({
  baseQuery: retry(ogBaseQuery(), {
    maxRetries: 3,
    backoff: (attempt) => {
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve();
        }, Math.max(attempt * 1000, 1000));
      });
    },
  }),
  reducerPath: 'callSessionOGReducerFromLibrary',
  endpoints: (builder) => ({
    postSession: builder.mutation<
      LbCallSession,
      { roomId: string; payload: PostSessionDTO }
    >({
      query: (data) => {
        return {
          url: `/rooms/${data.roomId}/sessions`,
          method: 'POST',
          body: data.payload,
        };
      },
    }),

    postSessionParticipants: builder.mutation<
      undefined,
      { sessionId: string; payload: PostSessionParticipantsDTO }
    >({
      query: (data) => {
        return {
          url: `/sessions/${data.sessionId}/sessionParticipants`,
          method: 'POST',
          body: data.payload,
        };
      },
    }),

    postSessionEnd: builder.mutation<
      undefined,
      { sessionId: string; participantsCount?: number }
    >({
      query: (data) => {
        return {
          url: `/sessions/${data.sessionId}/end`,
          method: 'POST',
          body:
            data.participantsCount !== undefined
              ? { participantsCount: data.participantsCount }
              : undefined,
        };
      },
    }),

    getSessions: builder.query<LbCallSession[], { input: GetSessionsInput }>({
      query: (data) => {
        return {
          url: `/sessions/getMeetingHistory`,
          method: 'post',
          body: data.input,
        };
      },
      extraOptions: {
        maxRetries: 0,
      },
    }),

    getSessionsForCsv: builder.query<
      SessionResultForCsv[],
      { input: GetSessionsInput }
    >({
      query: (data) => {
        return {
          url: '/sessions/getMeetingHistoryForCSV',
          method: 'post',
          body: data.input,
        };
      },
      extraOptions: {
        maxRetries: 0,
      },
    }),
  }),
});

export const { usePostSessionMutation } = callSessionOGService;
